import { Stack } from "@mui/material";
import React from "react";
import DevNewsForm from "../../components/DevNewsForm";

const Section5 = ({ signUpFormData }) => {
  return (
    <Stack
      sx={{
        position: "relative",
        alignItems: "center",
        pb: "40px",
      }}
    >
      <Stack
        sx={{
          maxWidth: "1240px",
          width: "100%",
          mt: "-60px",
        }}
      >
        <DevNewsForm signUpFormData={signUpFormData} />
      </Stack>
    </Stack>
  );
};

export default Section5;
